// extracted by mini-css-extract-plugin
export default {"talents":"talents-page_talents__FY8JD"};